export default "/img/CU.f8befb542174cdd8bb979d4db77c4ad2.png";